export const types = {
	TEXT_ANSWERS: 'TEXT_ANSWERS',
	CIRCLES_ANSWERS: 'CIRCLES',
	WITHOUT_EMOJI_TEXT_ANSWERS: 'WITHOUT_EMOJI_TEXT_ANSWERS',
	MEDIA_ANSWERS: 'MEDIA_ANSWERS',
	IMAGE_ANSWERS: 'IMAGE_ANSWERS',
}
